export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const CREATE_STREAM = 'CREATE_STREAM';
export const FETCH_STREAMS = 'FETCH_STREAMS';
export const FETCH_STREAM = 'FETCH_STREAM';
export const DELETE_STREAM = 'DELETE_STREAM';
export const EDIT_STREAM = 'EDIT_STREAM';

export const GET_WORD = 'GET_WORD';
export const UPDATE_WORD = 'UPDATE_WORD';


// USER
export const SET_USER = 'SET_USER';
export const GET_USER = 'GET_USER';


// RECENT ORDER HISTORY
export const SET_ORDER_HISTORY = 'SET_ORDER_HISTORY';


// ORDER PROCESS 
export const GET_ORDER_NUMBER = 'GET_ORDER_NUMBER';
export const UPDATE_ORDER_NUMBER = 'UPDATE_ORDER_NUMBER';
export const RESET_ORDER = 'RESET_ORDER';
export const UPDATE_ORDER = 'UPDATE_ORDER';
export const SET_BRANCHES = 'SET_BRANCHES';
export const UPDATE_SELECTED_BRANCH = 'UPDATE_SELECTED_BRANCH';
export const SET_DELIVERY_SITES = 'SET_DELIVERY_SITES';
export const SET_VALID_QUOTES = 'SET_VALID_QUOTES';
export const UPDATE_SELECTED_QUOTE = 'UPDATE_SELECTED_QUOTE';
export const UPDATE_SELECTED_DELIVERY_SITE = 'UPDATE_SELECTED_DELIVERY_SITE';
export const UPDATE_SPECIAL_INSTRUCTIONS = 'UPDATE_SPECIAL_INSTRUCTIONS';
export const UPDATE_REQ_DELIVERY_DATE = 'UPDATE_REQ_DELIVERY_DATE';
export const SET_PRODUCT_LIST = 'SET_PRODUCT_LIST';
export const SET_PRODUCT_GROUPS = 'SET_PRODUCT_GROUPS';
export const UPDATE_PRODUCT_LIST = 'UPDATE_PRODUCT_LIST';
export const SET_MIN_AND_MAX_ORDER_WEIGHT = 'SET_MIN_AND_MAX_ORDER_WEIGHT';
export const SET_CUSTOMER_SURCHARGES_LIST = 'SET_CUSTOMER_SURCHARGES_LIST';
export const SET_SELECTED_PRODUCTS_LIST = 'SET_SELECTED_PRODUCTS_LIST';
export const SET_ORDER_SUMMARY_RESULT = 'SET_ORDER_SUMMARY_RESULT';
export const RESET_ORDER_SUMMARY_RESULT = 'RESET_ORDER_SUMMARY_RESULT';
export const SET_PRODUCT_PRICE_PREVIEW = 'SET_PRODUCT_PRICE_PREVIEW';
export const UPDATE_NMBS_REFERENCE = 'UPDATE_NMBS_REFERENCE';
export const FORCE_USER_BACK = 'FORCE_USER_BACK';
export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';
export const SET_PRODUCT_LOADING = 'SET_PRODUCT_LOADING'; 
export const RESET_PRODUCT_BASKET = 'RESET_PRODUCT_BASKET';

export const UPDATE_WEIGHT = 'UPDATE_WEIGHT';

export const INSERT_ORDER = 'INSERT_ORDER';

export const IS_LOADING = 'IS_LOADING';
export const LOGGING_IN_ERROR = 'LOGGING_IN_ERROR';
export const SAVED_USERNAME = 'SAVED_USERNAME';

export const UPDATE_FPMCCANN_ORDER_NUMBER = 'UPDATE_FPMCCANN_ORDER_NUMBER';
export const POPULATE_FROM_BASKET = 'POPULATE_FROM_BASKET';
export const DELETE_BASKET = 'DELETE_BASKET';
export const SET_ORDER_ERROR = 'SET_ORDER_ERROR';
export const SET_ORDER_SUMMARY_ERROR = 'SET_ORDER_SUMMARY_ERROR';
export const SET_ORDER_SAVE_ERROR = 'SET_ORDER_SAVE_ERROR';

export const NOTIFICATION_TEXT = 'NOTIFICATION_TEXT';

export const RETURN_PALLETS = "RETURN_PALLETS";

export const TILE_INTEREST = "TILE_INTEREST";

export const UPDATE_LORRYLOAD = "UPDATE_LORRYLOAD";

//ADMIN AREA
export const GET_CUSTOMER_LIST = 'GET_CUSTOMER_LIST';
export const GET_SELECTED_CUSTOMER = 'GET_SELECTED_CUSTOMER';
export const GET_QLOAD_CUSTOMER_LIST = 'GET_QLOAD_CUSTOMER_LIST';

